import { combineReducers } from "redux";
import homeReducer from "./homeReducer";
// import persistedReducer from "./persistedReducer";
import activationSalesReducer from "./activationSalesReducer";
import rechargeSalesReducer from "./rechargeSalesReducer";
import payoutReducer from "./payoutReducer";
import retailerPerformanceReducer from "./retailerPerformanceReducer";
import earningReducer from "./earningsReducer";
import estelLedgerReducer from "./estelLedgerReducer";
import operationalDashboardReducer from "./operationalDashboardReducer";
import dashboardAccessibilityReducer from "./dashboardAccessibilityReducer";
import Ed1AndEd2Reducer from "./ed1AndEd2Reducer";
import schemeOverviewReducer from "./schemeOverview";
import edOrdersSummaryReducer from "./edOrdersSummary";

const rootReducers = combineReducers({
  homeReducer,
  activationSalesReducer,
  rechargeSalesReducer,
  // persistedReducer,
  payoutReducer,
  retailerPerformanceReducer,
  earningReducer,
  estelLedgerReducer,
  operationalDashboardReducer,
  dashboardAccessibilityReducer,
  Ed1AndEd2Reducer,
  schemeOverviewReducer,
  edOrdersSummaryReducer,
});

export default rootReducers;
